(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v4"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (typeof jQuery === 'undefined') return;
  var $ = jQuery;

  var $slideshow = $('.js-slideshow-v4');

  if ($slideshow.length && window.innerWidth >= 1024) {
    // Wait a bit to make sure Slick is initialized by the theme
    setTimeout(function() {
      try {
        // Force autoplay ON on desktop
        $slideshow.slick('slickSetOption', 'autoplay', true, true);
        $slideshow.slick('slickPlay');
      } catch (e) {
        console.warn('Slideshow autoplay override failed:', e);
      }
    }, 800);
  }
});

  } catch(e) { console.error(e); }
})();
})();
